<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog title="Commissie staffel" :small="true">
      <slot name="load"> </slot>
      <dean-notification :is-modal="true"> </dean-notification>
      <dean-form-row
        id="name"
        label="naam"
        type="text"
        v-model="data.name"
        :warning="$v.data.name.$error"
        @focus="$v.data.name.$touch()"
        :required-field="true"
      ></dean-form-row>
      <dean-form-row
        id="code"
        label="code"
        type="text"
        v-model="data.code"
      ></dean-form-row>
      <dean-form-row
        id="from"
        label="van"
        type="text"
        v-model="data.from"
        :warning="$v.data.from.$error"
        @focus="$v.data.from.$touch()"
        :required-field="true"
      ></dean-form-row>
      <dean-form-row
        id="to"
        label="tot"
        type="text"
        v-model="data.to"
      ></dean-form-row>
      <span slot="dean-dialog-button-group">
        <dean-button
          :danger="true"
          :dialog-button="true"
          @click.native="close()"
          >Annuleren</dean-button
        >
        <dean-button
          :success="true"
          :dialog-button="true"
          @click.native="send()"
          >Versturen</dean-button
        >
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import axios from 'axios';
import {
  // SVG
  warningIcon,
  // COMPONENTS
  deanDialog,
} from '@deanone/dean-components';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import { validationMixin } from 'vuelidate';
import { required, numeric } from 'vuelidate/lib/validators';
import { Validations } from 'vuelidate-property-decorators';
import { createNotification } from '@/mixins/validations';
import { deanDialogBus } from '@/main';

@Component({
  components: {
    warningIcon,
    DeanNotification,
    deanDialog,
    deanButton,
    deanFormRow,
  },
  mixins: [validationMixin],
})
export default class GateDialog extends Vue {
  // DATA
  @Prop() public payloadData!: {
    [key: string]: string;
  };
  public data: any = {
    name: '',
    code: '',
    from: '',
    to: '',
  };
  public url: string = '';
  public urlParams: any = {};

  // COMPUTED
  @Validations()
  get validations() {
    return {
      data: {
        name: { required },
        from: { required, numeric },
      },
    };
  }

  // METHODS
  public close() {
    deanDialogBus.$emit('close');
  }

  public send() {
    this.$v.$touch();

    if (!this.$v.$invalid) {
      this.$emit('setLoad', true);

      interface GateSaveRequestMapper {
        id: string;
        planId: string;
        name: string;
        code: string;
        from: number;
        to: number;
      }

      const gateSaveRequestMapper: GateSaveRequestMapper = {
        id: this.payloadData.id,
        planId: this.payloadData.planId,
        name: this.data.name,
        code: this.data.code,
        from: this.data.from,
        to: this.data.to,
      };

      this.$store
        .dispatch('processRecurringCommissionPlanGate', gateSaveRequestMapper)
        .then((response: any) => {
          deanDialogBus.$emit('gateChanged');
          this.close();
        })
        .catch((error: any) => {
          // TODO Doesn't always show the correct error message yet
          this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
        })
        .finally(() => {
          this.$emit('setLoad', false);
        });
    } else {
      this.$toast(createNotification(this.$v));
    }
  }

  public created() {
    if (this.payloadData.id) {
      interface GateInfoRequestMapper {
        id: string;
        planId: string;
        startDate: string;
        endDate: string;
      }

      const gateInfoRequestMapper: GateInfoRequestMapper = {
        id: this.payloadData.id,
        planId: this.payloadData.planId,
        startDate: this.payloadData.startDate,
        endDate: this.payloadData.endDate,
      };

      this.$emit('setLoad', true);

      this.$store
        .dispatch('requestRecurringCommissionPlanGate', gateInfoRequestMapper)
        .then(
          (response: any) => {
            interface GateInfoResponseMapper {
              name: string;
              code: string;
              from: number;
              to: number;
            }

            const gateInfoResponseMapper: GateInfoResponseMapper = {
              name: response.data.data.name,
              code: response.data.data.code,
              from: response.data.data.from,
              to: response.data.data.to,
            };

            this.data = gateInfoResponseMapper;
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveDataModal);
          },
        )
        .finally(() => {
          this.$emit('setLoad', false);
        });
    }
  }

  public destroyed() {
    this.$emit('setLoad', false);
  }
}
</script>

<!-- STYLE -->
<style lang='scss' scoped></style>
